import { API_URL_WEBINAR } from "@constants/env";
import apiInstance from "@services/Shared/instanceAxios";

const deleteWebinar = (uuid: string) =>
  apiInstance({
    url: API_URL_WEBINAR + uuid,
    method: "delete",
  });

export default deleteWebinar;
